var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataProxy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10790_64464)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_10790_64464)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8954 12.1416C15.1809 12.1416 13.7516 13.4872 13.7516 15.1949C13.7516 16.9025 15.1809 18.2481 16.8954 18.2481C18.6098 18.2481 20.0391 16.9025 20.0391 15.1949C20.0391 13.4872 18.6098 12.1416 16.8954 12.1416ZM15.0016 15.1949C15.0016 14.2203 15.8277 13.3916 16.8954 13.3916C17.9629 13.3916 18.7891 14.2203 18.7891 15.1949C18.7891 16.1694 17.9629 16.9981 16.8954 16.9981C15.8277 16.9981 15.0016 16.1694 15.0016 15.1949ZM12.9851 24.9091C12.9851 22.863 14.7135 21.165 16.8951 21.165C17.7757 21.165 18.5849 21.4431 19.2361 21.91C19.5166 22.1112 19.9071 22.0469 20.1082 21.7664C20.3094 21.4859 20.2451 21.0954 19.9646 20.8942C19.1053 20.278 18.0422 19.915 16.8951 19.915C14.0675 19.915 11.7351 22.1292 11.7351 24.9091V30.2491C11.7351 31.1522 12.4883 31.845 13.3679 31.845H18.8951C19.2403 31.845 19.5201 31.5652 19.5201 31.22C19.5201 30.8748 19.2403 30.595 18.8951 30.595H13.3679C13.1343 30.595 12.9851 30.4184 12.9851 30.2491L12.9851 24.9091ZM25.6003 22.625C23.1841 22.625 21.2253 24.5838 21.2253 27C21.2253 29.4162 23.1841 31.375 25.6003 31.375C28.0166 31.375 29.9753 29.4162 29.9753 27C29.9753 24.5838 28.0166 22.625 25.6003 22.625ZM19.9753 27C19.9753 23.8934 22.4937 21.375 25.6003 21.375C28.7069 21.375 31.2253 23.8934 31.2253 27C31.2253 30.1066 28.7069 32.625 25.6003 32.625C22.4937 32.625 19.9753 30.1066 19.9753 27ZM26.1003 24.5C26.1003 24.2239 25.8765 24 25.6003 24C25.3242 24 25.1003 24.2239 25.1003 24.5V26.5H23.1003C22.8242 26.5 22.6003 26.7239 22.6003 27C22.6003 27.2761 22.8242 27.5 23.1003 27.5H25.1003V29.5C25.1003 29.7761 25.3242 30 25.6003 30C25.8765 30 26.1003 29.7761 26.1003 29.5V27.5H28.1003C28.3765 27.5 28.6003 27.2761 28.6003 27C28.6003 26.7239 28.3765 26.5 28.1003 26.5H26.1003V24.5Z",
    fill: "#1B202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10790_64464",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10790_64464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataProxy);
export default __webpack_public_path__ + "static/media/data-proxy.66d424caeecbb596dce8e18f16b30119.svg";
export { ForwardRef as ReactComponent };